import * as React from 'react';
import GamePageLayout from '../../../components/GamePageLayout';
import Footer from '../../../components/Footer/Footer';
import {HOME_ACTION_PERSIST,HOME_ACTION_CLEAR} from "../../../redux/Home/home.constant";
import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'
import GameNavbar from "../../../components/GameNavbar";
import GameHeader from "../../../components/GameHeader";
import appService from '../../../Service'
import './styles.css'
import {useState} from "react";
import {confirmDialog, showErrorDialog, showSuccessDialog,Button,showLoading,Util} from "baziigram";
import  {STORAGE_KEY,dictionary} from "../../../constants";
import gameanalytics from "gameanalytics";
import {useDispatch, useSelector} from "react-redux";
import {persist} from "../../../redux/actions";
import {STORE_ACTION_PERSIST , STORE_ACTION_CLEAR} from "../../../redux/Store/store.constant.js"
import {GetUser , UpdateUser} from "../../../Util/user";

const StorePage = (props) => {
const { gameId , language , items , serverError,achievements,user,className } = useSelector(state => state.store);
  const dispatch = useDispatch();
  const updateState=(state)=>{
    dispatch(persist(state, STORE_ACTION_PERSIST))

  }

    React.useEffect(()=>{
           let l = Util.getLanguage()
           updateState({language:l , className:l=="fa"?"rtl text-right" : "ltr text-left",
           user:GetUser()})
          },[])

    React.useEffect(()=>{
     if(user && user.levelInfo && user.levelInfo.achievement)
                updateState({achievements:user.levelInfo.achievement})
     },[user])

    React.useEffect(()=>{

    if(props.location.state && props.location.state.gameId)
     updateState({gameId:props.location.state.gameId})

       if(gameId)
        loadItems()

    },[gameId])


    const loadItems=()=>{
        updateState({serverError:null})
        appService.GetAchivements(gameId).then(res=>{
            let list = {}
            res.list.map(item=>{
                list[item.id] = item
            })
            updateState({items:list})

        }).catch(err=>{
            updateState({serverError:dictionary.retryText[language]})
        })
    }



    const scrollToNews = ()=>{
        document.getElementById('news').scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
    }

   const  buyItem=(item)=>{
   let txt = language=="fa" ? ` آیا از خرید  ${item.name} اطمینان دارید؟ ` : `Do you confirm buying ${item.name}`
       let actions = [
           { title: dictionary.no[language], className: "baziigram-secondary-btn", action: null },
           {
               title: dictionary.yes[language],
               className: "baziigram-ok-btn",
               action: () => confirmBuy(item),
           },
       ];
       confirmDialog(txt,actions);
   }

   const confirmBuy=(item)=>{
       showLoading(true);
       appService
           .BuyAchievement(item.id , gameId)
           .then(res => {
           UpdateUser(res.userInfo)
           updateState({user:GetUser()})
               showSuccessDialog(dictionary.successfulPurchase[language], dictionary.success[language]);
               if(typeof window !== `undefined`) {
                   var gameanalytics = require('gameanalytics');
                   gameanalytics.GameAnalytics.initialize("712c556d47699b5e1d7beb4e004716cc",
                       "7838a8d082e4769dc7ddf99ea1f07fd3ab83322a");
                   gameanalytics.GameAnalytics.addResourceEvent(gameanalytics.EGAResourceFlowType.Sink, "Phoecoin",
                       item.requiredCoins, item.id, item.id, user);
               }

           })
           .catch(err => {
               showErrorDialog(err.message || err);
           })
           .finally(res => {
               showLoading(false);
           });
   }



    return (
        <GamePageLayout type={STORE_ACTION_CLEAR}>
            <GameNavbar backUrl={"/Game/LifeStone"}/>
            <div className={"rtl"}>
                <GameHeader class={"d-flex  home-header"}>


                        <div className={"text_header text-center d-flex flex-column justify-content-center align-items-center"}>
                            <div dangerouslySetInnerHTML={{__html: dictionary.storeHeader[language]}} />
                            <Button className={"mt-3"} onClick={scrollToNews} title={dictionary.seeItems[language]}></Button>

                        </div>

                </GameHeader>


                {achievements && items && <div className={"achivement-container"}>
                    <div className={`${className} mb-2`}>{dictionary.myAssets[language]}:</div><div className="d-flex flex-row align-items-end" >

                    {
                          Object.keys(achievements).map(key=>{
                            return <div   className={"mx-2 d-flex flex-column align-items-center"}>
                                <img width="80px"  src={items[key].logo}/>
                                    <div className={"  w-100 my-1 text-center"}> {items[key].name} </div>
                                <div className={"  w-100 my-1 text-center"}> {achievements[key]} </div>
                            </div>

                        })
                    }
                </div></div>}


                <div id={"news"} className='main_container'>
                    {/* <div className="main_container"> */}

                    {items==null && serverError==null && <div
                        className={`baziigram-spinner mt-5 spinner-border text-light m-auto`}
                        role="status"
                    ></div>}
                    {serverError && <div className={"text-center text-warning "}>
                        {serverError}
                        <Button onClick={loadItems} className={"mt-3"} title={dictionary.retry[language]}/>
                    </div>}
                    {items != null && serverError==null && <>


                        <div className="grid-container rtl">
                            <div
                                className={`store-container row align-items-start justify-content-center`}
                                style={{ rowGap: '50px', paddingTop: '50px' }}
                            >
                                {
                                    items && Object.keys(items).map(key=>{
                                        return <div   className=" col-12 col-lg-3  my-4">
                                               <div className={"storeItem d-flex flex-column align-items-center justify-content-between"}>
                                                   <div className={"text-center my-2"}>{items[key].name}</div>
                                                   <img style={{opacity:!items[key].isDisabled? '1' : '0.6'}} className={"storeItemLogo"}  src={items[key].logo} width={"80px"}/>
                                                   <div className={"d-flex w-100 flex-row align-items-center justify-content-end"}>
                                                       <div className={"text-center my-2"}>{items[key].requiredCoins}</div>
                                                       <img className="mr-2 ml-4" src={"/images/icons/coin2.png"} width={"22px"}/>
                                                    </div>
                                                 {!items[key].isDisabled &&  <Button className={"buyButton"} title={dictionary.buy[language]} onClick={()=>{buyItem(items[key])}}/>}
                                               </div>

                                        </div>
                                    })
                                }

                            </div>

                        </div>
                    </>}



                </div>


            </div>

        </GamePageLayout>
    )
}

export default StorePage;
